var WorkingStudiesFakeData = [
    {
        id: 1,
        image: 'https://i.ibb.co/mcJrqkD/gallery-1.jpg',
        studiesTitle: 'Web Development'
    },
    {
        id: 2,
        image: 'https://i.ibb.co/4fnF5DL/gallery-2.jpg',
        studiesTitle: 'Business Development'
    },
    {
        id: 3,
        image: 'https://i.ibb.co/tPMB78n/gallery-3.jpg',
        studiesTitle: 'Android Development'
    },
    {
        id: 4,
        image: 'https://i.ibb.co/ZdD87W4/gallery-4.jpg',
        studiesTitle: 'MERN Stack Development'
    },
    {
        id: 5,
        image: 'https://i.ibb.co/4fnF5DL/gallery-2.jpg',
        studiesTitle: 'PHP Development'
    },
    {
        id: 6,
        image: 'https://i.ibb.co/tPMB78n/gallery-3.jpg',
        studiesTitle: 'Digital Marketing'
    }
];

export default WorkingStudiesFakeData;